var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKnowTypes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.175 12.85h1v-2h1q.425 0 .713-.288.287-.287.287-.712v-1q0-.425-.287-.713-.288-.287-.713-.287h-2Zm1-3v-1h1v1Zm2.95 3h2q.425 0 .713-.288.287-.287.287-.712v-3q0-.425-.287-.713-.288-.287-.713-.287h-2Zm1-1v-3h1v3Zm2.95 1h1v-2h1v-1h-1v-1h1v-1h-2ZM8.2 18.075q-.925 0-1.6-.675t-.675-1.6V3.925q0-.925.675-1.6t1.6-.675h11.875q.925 0 1.6.675t.675 1.6V15.8q0 .925-.675 1.6t-1.6.675Zm0-2.275h11.875V3.925H8.2V15.8Zm-4.275 6.55q-.925 0-1.6-.675t-.675-1.6V5.925h2.275v14.15h14.15v2.275ZM8.2 3.925V15.8 3.925Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowTypes);
export default __webpack_public_path__ + "static/media/know_types.3b1896e5ab61def7c4083ebf6ce01927.svg";
export { ForwardRef as ReactComponent };